
// 七牛云-华北区
const upload_url = '/admin/ali_oss/index';

// 请求地址
const admin_api = '/admin';    // 测试环境

export default {
    upload_url,
    admin_api,
}



// WEBPACK FOOTER //
// ./src/util/common.js